<template>
  <div>
    <a-card class="margin-bottom">
      <a-form-model ref="formInput" :model="form" :rules="rules">
        <a-row :gutter="12">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item label="Product/Work" prop="produk_name">
              <a-input v-model="form.produk_name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="PN" prop="pn">
              <a-input v-model="form.pn"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Quantity" prop="qty">
              <a-input-number
                v-model="form.qty"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item label="Unit" prop="unit">
              <a-input v-model="form.unit"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Unit Price" prop="unit_price">
              <a-input-number
                v-model="form.unit_price"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Note" prop="note">
              <a-input v-model="form.note"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="action">
        <a-button-group>
          <a-button type="default" @click="handleDetail">{{
            isEdit.status ? "Submit Changes" : "Add Detail"
          }}</a-button>
          <a-button
            v-if="isEdit.status"
            type="primary"
            @click="handleCancel"
            icon="close"
          ></a-button>
        </a-button-group>
      </div>
    </a-card>
    <a-card title="Detail List">
      <span slot="extra">
        <h4 class="m-text-align right margin-remove">
          Grand Total :
          {{
            formatCurrency(
              dataProcessed.AccountDetail.project_currency,
              sum_table
            )
          }}
        </h4>
      </span>
      <a-table
        :pagination="false"
        bordered
        rowKey="id_sc_dtl_product"
        :columns="columns"
        :data-source="getDetailProduct"
      >
        <span slot="title_total_price"
          >Total Price (
          {{ dataProcessed.AccountDetail.project_currency }} )</span
        >
        <span slot="total_price" slot-scope="text">
          {{
            formatCurrency(
              dataProcessed.AccountDetail.project_currency,
              mode == "Create"
                ? text.unit_price * text.qty
                : text.unit_price * text.qty
            )
          }}
        </span>
        <span slot="unitPrice"
          >Unit Price (
          {{ dataProcessed.AccountDetail.project_currency }} )</span
        >
        <a-button-group slot="action" slot-scope="item, record">
          <a-button
            @click="handleEdit(item)"
            type="primary"
            icon="edit"
          ></a-button>
          <a-button
            icon="close"
            @click="handleRemove(item)"
          ></a-button> </a-button-group
        >s
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import nanoid from "nanoid";
export default {
  name: "Product-Detail",
  props: { dataProcessed: {}, mode: String },
  mixins: [CurrencyFormat],
  data() {
    const columns = [
      {
        title: "Product/Work",
        dataIndex: "produk_name",
        key: "product_name",
      },
      {
        title: "PN",
        dataIndex: "pn",
        key: "pn",
      },
      {
        title: "Unit",
        dataIndex: "unit",
        key: "unit",
      },
      {
        title: "Note",
        dataIndex: "note",
        key: "note",
      },
      {
        title: "QTY",
        dataIndex: "qty",
        align: "right",
        key: "qty",
      },
      {
        dataIndex: "unit_price",
        key: "unit_price",
        slots: { title: "unitPrice" },
        align: "right",
        scopedSlots: { customRender: "upInput" },
        width: 200,
      },
      {
        key: "total_price",
        align: "right",
        slots: { title: "title_total_price" },
        scopedSlots: { customRender: "total_price" },
        width: 200,
      },
      {
        title: "Action",
        width: 100,
        key: "action",
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];
    return {
      columns,
      form: {},
      rules: {
        produk_name: {
          required: true,
          message: "Please input Product",
          trigger: "blur",
        },
        pn: {
          required: true,
          message: "Please input pn",
          trigger: "blur",
        },
        qty: {
          required: true,
          message: "Please input quantity",
          trigger: "blur",
        },
        unit: {
          required: true,
          message: "Please input unit",
          trigger: "blur",
        },
        unit_price: {
          required: true,
          message: "Please input unit price",
          trigger: "blur",
        },
      },
      isEdit: {
        status: false,
        item: {},
      },
    };
  },
  computed: {
    ...mapGetters(["getDetailProduct"]),
    sum_table() {
      return this.getDetailProduct.reduce((sum, item) => 
          sum + parseInt(item.qty) * parseInt(item.unit_price),
          0
      );
    },
  },
  methods: {
    onChange(key, value) {
      const source = [...this.getDetailProduct];
      const target = source.find((item) => item.pn == key.pn);

      if (target) {
        if (this.mode == "Create") {
          target.unitPrice = value;
        } else {
          target.unit_price = value;
        }
        this.$store.dispatch("setDetailProduct", source);
      }
    },
    handleRef() {
      if (this.isEdit.status) {
        this.displayMessageValue("basic-error", "Complete your changes!");
        return;
      }

      let isEmpty;
      isEmpty = this.getDetailProduct.filter(
        (item) => parseFloat(item.unit_price <= 0) || item.unit_price == null || item.unit_price == 0
      );
      if (isEmpty.length > 0) {
        this.displayMessageValue(
          "basic-error",
          "Unit Price must be more than 0. Please check your detail!"
        );
        return;
      }

      Event.$emit("dataProcessed", this.getDetailProduct);
    },
    handleDetail() {
      this.$refs.formInput.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.form.unit_price == 0) {
          this.displayMessageValue("error", "Unit Price must higher than 0");
          return;
        }
        if (this.form.qty == 0) {
          this.displayMessageValue("error", "Quantity must higher than 0");
          return;
        }

        const data = {
          currency: "IDR",
          id_sc_dtl_product: this.isEdit.item.id_sc_dtl_product,
          id:
            this.mode == "Create" && this.isEdit.status
              ? this.isEdit.item.id
              : nanoid(),
          note: this.form.note ? this.form.note : "",
          pn: this.form.pn,
          produk_name: this.form.produk_name,
          qty: this.form.qty,
          unit: this.form.unit,
          unit_price: this.form.unit_price,
        };

        if (this.isEdit.status) {
          try {
            this.$store
              .dispatch("editDetailProduct", {
                value: data,
                mode: this.mode,
              })
              .then((res) => {
                this.isEdit = {
                  item: {},
                  status: false,
                };
                this.displayMessage("success-edit");
              });
          } catch (err) {
            return err;
          } finally {
            this.$refs.formInput.resetFields();
          }
        } else {
          this.$refs.formInput.resetFields();
          this.$store.dispatch("addDetailProduct", data);
        }
      });
    },
    handleEdit(item) {
      const data = {
        currency: item.currency,
        id_sc_dtl_product: item.id_sc_dtl_product,
        id: item.id,
        note: item.note,
        pn: item.pn,
        produk_name: item.produk_name,
        qty: item.qty,
        unit: item.unit,
        unit_price: item.unit_price,
      };

      this.form = JSON.parse(JSON.stringify(data));

      this.isEdit = {
        status: true,
        item: item,
      };
    },
    handleRemove(item) {
      this.$store.dispatch("removeDetailProduct", item);
      Event.$emit("refreshProductDetail");
    },
    handleCancel() {
      this.isEdit = {
        status: false,
        item: {},
      };
      this.form = {};
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
